import React, {Component} from 'react'
import PropTypes from 'prop-types'

import styles from './SpanButton.less'
import Cookies from "js-cookie";

const {
    'span-button': button_class,
    'red': red_class,
    'green': green_class,
    'blue': blue_class,
    'yellow': yellow_class,
    'purple': purple_class,
} = styles

export const Colors = {
    RED: 'red',
    GREEN: 'green',
    BLUE: 'blue',
    YELLOW: 'yellow',
    PURPLE: 'purple',
}

export default class SpanButton extends Component {
    render() {
        const {color, className, children, ...props} = this.props

        let button_classes = [button_class]
        const v2 = Cookies.get('force_set_wa_backend_ui_version') == 2
        let class_name = ''
        if(v2) {
            button_classes = []
            class_name += 'button '
        }
        if (className) {
            button_classes.push(className)
        }

        if (color && styles[color]) {
            if(v2) {
                class_name += color + ' '
            } else {
                button_classes.push(styles[color])
            }
        }

        return (
            <span className={class_name + button_classes.join(' ')} {...props}>
				{children}
			</span>
        )
    }
}

SpanButton.propTypes = {
    color: PropTypes.any,
    className: PropTypes.any,
    onClick: PropTypes.any,
}